import type { VehicleInput } from './vehicleDynamics';

export interface InputConditionerConfig {
  steerRatePerSecond: number;
  returnRatePerSecond: number;
}

export const DEFAULT_INPUT_CONDITIONER: Readonly<InputConditionerConfig> = Object.freeze({
  steerRatePerSecond: 2.5,
  returnRatePerSecond: 3.5,
});

/** Time-based progressive digital steering, independent of render refresh. */
export class InputConditioner {
  private steering = 0;

  constructor(private readonly config = DEFAULT_INPUT_CONDITIONER) {}

  sample(raw: VehicleInput, dt: number): VehicleInput {
    const seconds = Number.isFinite(dt) ? Math.max(0, dt) : 0;
    const target = Math.max(-1, Math.min(1, raw.steer));
    const rate = target === 0 ? this.config.returnRatePerSecond : this.config.steerRatePerSecond;
    const delta = Math.max(-rate * seconds, Math.min(rate * seconds, target - this.steering));
    this.steering = Math.max(-1, Math.min(1, this.steering + delta));
    return {
      throttle: Math.max(0, Math.min(1, raw.throttle)),
      brake: Math.max(0, Math.min(1, raw.brake)),
      steer: this.steering,
    };
  }

  reset(): void {
    this.steering = 0;
  }
}
